// extracted by mini-css-extract-plugin
module.exports = {"faq_embedded_maker_wrapper":"faqEmbeddedMaker_faq_embedded_maker_wrapper__jgeAw"};